import {Add} from './variant/add';
import {Edit} from './variant/edit';

export const SpecialistGroupDrawer = {
	Add,
	Edit,
};
export * from './events';
